import { z } from "zod";
import { ControlDataTypeKey, Types } from "../prop-controllers";
import { P, match } from "ts-pattern";
const datePropControllerDataV0Schema = z.string();
const DatePropControllerDataV1Type = "prop-controllers::date::v1";
const datePropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(DatePropControllerDataV1Type),
  value: z.string()
});
const datePropControllerDataSchema = z.union([
  datePropControllerDataV0Schema,
  datePropControllerDataV1Schema
]);
function Date(options = {}) {
  return { type: Types.Date, version: 1, options };
}
function getDatePropControllerDataString(data) {
  return match(data).with(
    { [ControlDataTypeKey]: DatePropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createDatePropControllerDataFromString(value, definition) {
  return match(definition).with(
    { version: 1 },
    P.nullish,
    () => ({
      [ControlDataTypeKey]: DatePropControllerDataV1Type,
      value
    })
  ).otherwise(() => value);
}
export {
  Date,
  DatePropControllerDataV1Type,
  createDatePropControllerDataFromString,
  datePropControllerDataSchema,
  getDatePropControllerDataString
};
//# sourceMappingURL=date.js.map